var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('el-tree',{ref:"tree",attrs:{"show-checkbox":_vm.showCheckbox,"node-key":"id","data":_vm.tableData,"highlight-current":true,"props":_vm.defaultProps},on:{"node-click":_vm.handleNodeClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }